import {
    AggregateFunctions,
    ApiQueryExample,
    FilterOperators,
    SortDirections,
} from "~/modules/filters/types";
import { TokenTimeseriesColumns, TokenTimeseriesGroupBy } from "../../types";
import { MEASURE_SLUGS } from "~/consts";

// // // //

const marketCapAll2023: ApiQueryExample = {
    key: "marketCapAll2023",
    content: {
        label: "2023 Market Cap",
        description: "Compare the market cap of tokens over 2023.",
    },
    query: {
        aggregate: {
            groupBy: TokenTimeseriesGroupBy.protocol,
            aggregateFunction: AggregateFunctions.Sum,
        },
        filter: {
            operator: FilterOperators.And,
            filters: [
                {
                    field: TokenTimeseriesColumns.measureSlug,
                    operator: FilterOperators.Equals,
                    value: MEASURE_SLUGS.total_asset_value_dollar,
                },
                {
                    field: TokenTimeseriesColumns.date,
                    operator: FilterOperators.OnOrAfter,
                    value: "2023-01-01T05:00:00.000Z",
                },
            ],
        },
        sort: {
            direction: SortDirections.asc,
            field: TokenTimeseriesColumns.date,
        },
        pagination: {
            page: 1,
            perPage: 25,
        },
    },
};

const marketCapAndMaxCapacityAll2023: ApiQueryExample = {
    key: "marketCapAll2023",
    content: {
        label: "2023 Market Cap + Max Capacity",
        description: "Compare the market cap of tokens over 2023.",
    },
    query: {
        aggregate: {
            groupBy: TokenTimeseriesGroupBy.protocol,
            aggregateFunction: AggregateFunctions.Sum,
        },
        filter: {
            operator: FilterOperators.And,
            filters: [
                {
                    field: TokenTimeseriesColumns.date,
                    operator: FilterOperators.OnOrAfter,
                    value: "2023-01-01T05:00:00.000Z",
                },
                {
                    operator: FilterOperators.Or,
                    filters: [
                        {
                            field: TokenTimeseriesColumns.measureSlug,
                            operator: FilterOperators.Equals,
                            value: MEASURE_SLUGS.total_asset_value_dollar,
                        },
                        {
                            field: TokenTimeseriesColumns.measureSlug,
                            operator: FilterOperators.Equals,
                            value: MEASURE_SLUGS.maximum_capacity_dollar,
                        },
                    ],
                },
            ],
        },
        sort: {
            direction: SortDirections.asc,
            field: TokenTimeseriesColumns.date,
        },
        pagination: {
            page: 1,
            perPage: 25,
        },
    },
};

export const API_QUERY_EXAMPLES: ApiQueryExample[] = [
    marketCapAll2023,
    marketCapAndMaxCapacityAll2023,
];
